import React, { FC } from 'react';
import { Table, TableBody, TableHead, TableCell } from '@material-ui/core';
import { MutationResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { useTranslation } from 'react-i18next';

import { SharesItem, QueryGetSharesItemsArgs, GetSharesItemsDocument } from 'api';
import { ResponsiveTable } from 'components';
import { deleteScheduledShares, updateScheduledShares } from 'apollo/reducers';

import DateCell from './Cells/Date';
import ImageCell from './Cells/Image';
import ScheduledShareCell from './Cells/ScheduledShare';
import ActionsCell from './Cells/Actions';
import { RowHead, RowBody } from './TableRow';

interface IProps {
  results: SharesItem[][];
  variables: QueryGetSharesItemsArgs;
}

const ScheduledShares: FC<IProps> = ({ results, variables }) => {
  const { t } = useTranslation();

  function refetchQueriesOnEdit() {
    return [
      {
        variables,
        query: GetSharesItemsDocument,
      },
    ];
  }

  function onDelete(cache: DataProxy, result: MutationResult['data']) {
    deleteScheduledShares({
      cache,
      result,
      variables,
      query: GetSharesItemsDocument,
    });
  }

  function onUpdate(cache: DataProxy, result: MutationResult['data']) {
    updateScheduledShares({
      cache,
      result,
      variables,
      query: GetSharesItemsDocument,
    });
  }

  return (
    <ResponsiveTable>
      <Table>
        <TableHead>
          <RowHead>
            <TableCell colSpan={4} size="small">
              {t('common:scheduled')}
            </TableCell>
          </RowHead>
        </TableHead>
        <TableBody>
          {results.map(shareItem => (
            <RowBody key={shareItem[0].id}>
              <DateCell time={shareItem[0].share_at} />
              <ImageCell content={shareItem[0].content} />
              <ScheduledShareCell items={shareItem} />
              <ActionsCell
                items={shareItem}
                refetchQueriesOnEdit={refetchQueriesOnEdit}
                onDelete={onDelete}
                onUpdate={onUpdate}
              />
            </RowBody>
          ))}
        </TableBody>
      </Table>
    </ResponsiveTable>
  );
};

export default ScheduledShares;
